module.exports = __webpack_public_path__ + "static/media/grid_1.6007e60d.jpg";